import getClientsMin from './getClientsMin'
import getAreas from './getAreas'
import saveItem from './saveItem'
import getItem from './getItem'

export const getClientsMinPromise = getClientsMin
export const getAreasPromise = getAreas
export const saveItemPromise = saveItem
export const getItemPromise = getItem
